















import { defineComponent } from '@vue/composition-api';
import { CopyToClipboardButton } from '.';
import { v4 as uuidv4 } from 'uuid';

export default defineComponent({
    name: 'PathRenderer',
    props: {
        path: { type: String, required: true },
        name: { type: String, required: false, default: () => `path_${uuidv4()}` },
        tooltip: { type: String, required: false },
        copyTooltip: { type: String, required: false },
    },
    components: { CopyToClipboardButton },
});
